<template>
  <div class="header" v-if="isMain">
    <div class="title">{{ title }}</div>
    <form class="form-container">
      <input class="search-input" type="text" id="searchInput" placeholder="Zoeken" aria-label="Zoeken"
             @input="emitSearch"
             v-model="searchValue"/>
      <button class="search-button" tabindex="0" aria-label="Search">
        <img src="/assets/search-black.svg" alt="Search icon" class="search-icon"/>
      </button>
    </form>
  </div>

  <section v-else class="revenue-section">
    <h2 class="revenue-title">{{ title }}</h2>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AllBvs',
  emits: ['search'],
  props: {
    isMain: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },
  setup(_, { emit }) {
    const searchValue = ref('')

    const emitSearch = () => {
      emit('search', searchValue.value)
    }

    return {
      searchValue,
      emitSearch
    }
  }
})
</script>

<style scoped>

.revenue-section {
  width: 100%;
}

.revenue-title {
  color: var(--Neutral-5, #191a1f);
  font: 500 16px Montserrat, sans-serif;
}

@media (max-width: 991px) {
  .revenue-title {
    max-width: 100%;
  }
}

.header {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  justify-content: space-between;
  flex-wrap: wrap;
}

@media (max-width: 991px) {
  .header {
    max-width: 100%;
  }
}

.title {
  color: var(--Neutral-5, #191a1f);
  font-size: 20px;
  margin: auto 0;
  align-self: stretch;
}

@media (max-width: 991px) {
  .search-container {
    max-width: 100%;
  }
}

.form-container {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  display: flex;
  min-height: 38px;
  gap: 8px;
  width: 185px;
  padding: 9px 8px;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.search-input {
  flex: 1;
  outline: none;
}

.search-button {
  background: none;
  border: none;
  cursor: pointer;
}

.search-icon {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
}
</style>